import * as React from "react";
import TextField from "@material-ui/core/TextField";
import UserDetailTopBar from "./Ops.Users.UserDetailTopBar";
import * as moment from "moment";
import UserWithdrawalRequestsContainer from "../../Withdrawals/UserWithdrawalRequestsContainer";
import { RouteComponentProps } from "react-router";
import { graphql, gql, MutationFunc, ChildProps } from "react-apollo";

type MutationResult = {
  withhold_withdrawal_request: {
    id: string;
  };
};

type GqlNamedMutation = {
  withholdWithdrawalMutation: MutationFunc<MutationResult>;
};

type State = {
  createdAtFrom: string;
  createdAtTo: string;
};

type Props = ChildProps<
  GqlNamedMutation & BOComponentProps & RouteComponentProps<{ id: string }>,
  MutationResult
>;

class UserWithdrawalList extends React.Component<Props, State> {
  state = {
    createdAtFrom: null,
    createdAtTo: null
  };

  setHeader(email: string) {
    this.props.setHeader({
      title: `Ops > ${email}`,
      description: "Wallet withdrawals for user"
    });
  }

  onChangeFromDate(yyyyMmDd) {
    this.setState({
      createdAtFrom: moment(yyyyMmDd, "YYYY-MM-DD").toISOString()
    });
  }

  onChangeToDate(yyyyMmDd) {
    this.setState({
      createdAtTo: moment(yyyyMmDd, "YYYY-MM-DD").toISOString()
    });
  }

  render() {
    return (
      <React.Fragment>
        <UserDetailTopBar />
        <section className="padded">
          <h3
            style={{
              borderBottom: "1px solid rgb(204, 204, 204)",
              fontWeight: 400,
              display: "flex",
              alignItems: "center",
              marginTop: 0
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start"
              }}
            >
              <TextField
                type="date"
                placeholder="From"
                onChange={event => this.onChangeFromDate(event.target.value)}
                style={{
                  width: "200px",
                  marginRight: "10px"
                }}
              />
              <TextField
                type="date"
                placeholder="To"
                onChange={event => this.onChangeToDate(event.target.value)}
                style={{
                  width: "200px",
                  marginRight: "10px"
                }}
              />
            </div>
          </h3>

          <UserWithdrawalRequestsContainer
            name={"ops.users.withdrawals"}
            onLoaded={this.setHeader.bind(this)}
            createdAtFrom={this.state.createdAtFrom}
            createdAtTo={this.state.createdAtTo}
          />
        </section>
      </React.Fragment>
    );
  }
}

const withWithholdWithdrawalMutation = graphql<MutationResult, Props>(
  gql`
    mutation WithholdWithdrawalRequest($reference: ID!, $comment: String) {
      withhold_withdrawal_request(reference: $reference, comment: $comment) {
        id
      }
    }
  `,
  { name: "withholdWithdrawalMutation" }
);

export default withWithholdWithdrawalMutation(UserWithdrawalList);
